import { render, staticRenderFns } from "./TicketMetadataGroup.vue?vue&type=template&id=139b2a32&scoped=true&"
import script from "./TicketMetadataGroup.vue?vue&type=script&lang=ts&"
export * from "./TicketMetadataGroup.vue?vue&type=script&lang=ts&"
import style0 from "./TicketMetadataGroup.vue?vue&type=style&index=0&id=139b2a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139b2a32",
  null
  
)

export default component.exports